import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import MyStorage from '../../common/MyStorage';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import SideMenu from '../../components/side-menu/SideMenu';
import { WebApiCalls } from "../../webApiCalls/webApiCalls"
import { KMTracking } from '../../components/Tracking/KMTracking';
import {
    UpdateCartCount,
    UpdateCartAmount
} from "../../redux/actions/postActions";
import {Link} from 'react-router-dom'

function Profile(props) {
    const [givenName, setGivenName] = useState('');
    useEffect(() => {
        const storage = new MyStorage()
        let userID =  storage.getUserId();
		let accessToken =  storage.getaccess_token();
        const is_logged_in = storage.getloggedIn();
        if (is_logged_in || is_logged_in == 'true') {
            console.log("Auth Token", is_logged_in)
            const given_name = localStorage.getItem('name')?.split(' ')[0];
            setGivenName(given_name ? given_name : '')
        } else {
            props?.history?.push('/login',{from:'Profile'})
        }
        if(userID && accessToken){
            seeCart()
          }else{props?.history?.push("/login", { from: "Profile" });}
        if (props?.history?.location) {
            window.scrollTo(0, 0)
        }
    }, [])
    const seeCart = async () => {
		let userID = await localStorage.getItem("UserId");
		let accessToken = await localStorage.getItem("access_token");
		await new WebApiCalls()
			.getCartDetail(userID, accessToken)
			.then(async (Response) => {
				if(Response.errorType){
					//redirect to login if expired
					props?.history?.push("/login", { from: 'Profile' })
				}
			});
	};
    const tracker = async (eventName, _kmprops) => {
        await KMTracking(eventName, _kmprops)
    }
    return (
        <div>
            <div className="viewport"></div>

            {/* /container */}
            <div className="container">

                {/* header */}
                <Header props={props} />
                {/* /header */}

            
                <MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>
                {/* /content */}
                {/* /content */}
                <div className="content">

                    {/* breadcrumb-back */}
                    <div className="breadcrumb-back">

                        {/* breadcrumb */}
                        <div className="breadcrumb" style={{ backgroundColor: "rgb(255,255,255,0.3)" }}>
                            <Link to="/">Home</Link>
                            {/* <a href="#">Account</a> */}
                            <a href="#">Profile</a>
                        </div>
                        {/* /breadcrumb */}

                        <a onClick={() => { props?.history?.goBack() }} className="backbtn">BACK</a>

                    </div>
                    {/* /breadcrumb-back */}

                    {/* product listing */}
                    <div className="account-page">

                        {/* two-columns */}
                        <div className="two-columns">

                            {/* left panel */}
                            <SideMenu props={props} />
                            {/* /left panel */}

                            {/* /right panel */}
                            <div className="right-panel">

                                <div className="no-order">
                                    Profile
                                    <span>Manage your profile on the Frasers Experience (FRx) App.</span>
                                    <br />

                                    <Link to="https://frxapp.page.link/frasers-experience" className="appdownload"
                                        onClick={() => {
                                            let data = { 'Current Page': 'Profile' }
                                            tracker('DownloadtheFrasersExperienceApp', data)
                                        }}
                                    >
                                        <img src="images/applogo.svg" alt="download app" />
                                        <div className="text">
                                            Download the
                                            Frasers Experience
                                            App
                                        </div>
                                    </Link>

                                </div>

                            </div>
                            {/* /right panel */}

                        </div>
                        {/* /two-columns */}

                    </div>
                    {/* /product listing */}

                </div>
                {/* /content*/}
                {/* /content*/}


            </div>

            <Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>


        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count,allCategories } = state.UserReducer
    return { cart_count,allCategories }
};
const actions = {
    UpdateCartCount,
    UpdateCartAmount
};
export default connect(mapStateToProps, actions)(Profile);